import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { JobExtensionInProgressProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/JobExtensionInProgressProgressionActions'

export interface JobExtensionInProgressProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const JobExtensionInProgressProgressionActionsContainer = observer(
  function JobExtensionInProgressProgressionActionsContainer({
    vm,
  }: JobExtensionInProgressProgressionActionsContainerProps) {
    return (
      <JobExtensionInProgressProgressionActions
        onUploadExtensionConfirmation={vm.viewExtensionDocumentCreationModal}
      />
    )
  },
)
